import { Field, InputType } from 'type-graphql'
import type { PurchaseOrderVendorOrShipToEnum } from '../PurchaseOrderVendorOrShipToEnum'
import type { UserTypeEnum } from '../../user/UserTypeEnum'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class UpdatePurchaseOrderVendorOrShipToArgs extends ActionArgs {
  @Field(() => String)
  userId: string

  @Field(() => String)
  type: PurchaseOrderVendorOrShipToEnum

  @Field(() => String)
  purchaseOrderId: string

  @Field(() => String)
  userType: UserTypeEnum

  @Field(() => String)
  email: string

  @Field(() => String, { nullable: true })
  name?: string

  @Field(() => String, { nullable: true })
  companyId?: string

  @Field(() => String, { nullable: true })
  companyName?: string

  @Field(() => Boolean, { nullable: true })
  skipDomain?: boolean
}
